import moneyUnit from "@/constants/moneyUnit.js";
import {
  fulfillmentStatusEnum,
  financialStatusEnum,
  statusEnum,
  currencyNameMap,
  payMethodMap,
} from "@/constants/index.js";

export function formatCanaryConfigValue(key) {
  let { canaryGlobalAttrs = {} } = self.SYSTEM_CONFIG || {};
  let configValueStr = canaryGlobalAttrs[key] || "";
  configValueStr = configValueStr.trim();
  if (!configValueStr) return;
  try {
    if (configValueStr.startsWith("{") || configValueStr.startsWith("["))
      return JSON.parse(configValueStr);
  } catch (e) {
    //console.error(e);
  }
  return configValueStr
    .split(/[,;\n]/g)
    .map((val) => val.trim())
    .filter(Boolean);
}

export function objToUrl(obj, options = {}) {
  if (!obj) return "";

  if (typeof options === "boolean") {
    options = { excludeRandomStr: options };
  }
  const { excludeRandomStr = false, prefixChar = "?" } = options;

  const url = Object.entries(obj)
    .map(([key, val]) => {
      if (val === undefined || val === null) return;
      if (typeof val === "object") val = JSON.stringify(val);
      return `${encodeURIComponent(key)}=${encodeURIComponent(val)}`;
    })
    .filter(Boolean);

  if (!url.length) return "";

  if (!excludeRandomStr)
    url.push("____r=" + Math.random().toString().substring(2) + Date.now());
  return prefixChar + url.join("&");
}

export const getCurrency = (data) => {
  const { currency } = data || {};
  return moneyUnit[currency];
};

export const getPromotionMessage = ({ promotionType, local, data }) => {
  const promotionTipList = [];
  if (promotionType == 0) {
    promotionTipList.push(local("noDiscountAvailable"));
  } else if (promotionType == 1) {
    promotionTipList.push(local("itemDiscount"));
  } else if (promotionType == 2) {
    promotionTipList.push(local("memberDiscount"));
  } else if (promotionType == 3) {
    promotionTipList.push(local("discountForBulkPurchase"));
    for (let item of data.productLadderList) {
      promotionTipList.push(
        `${local("buy_0ItemsGet_1Off")
          ?.replace("{0}", item.count)
          ?.replace("{1}", item.discount * 10)}`
        // "满" + item.count + "件打" + item.discount * 10 + "折"
      );
    }
  } else if (promotionType == 4) {
    promotionTipList.push(local("discountOnReachingACertainAmount"));
    for (let item of data.productFullReductionList) {
      promotionTipList.push(
        `${local("spend_0YuanSave_1Yuan")
          ?.replace("{0}", item.fullPrice)
          ?.replace("{1}", item.reducePrice)}`
        // "满" + item.fullPrice + "元减" + item.reducePrice + "元"
      );
    }
  } else if (promotionType == 5) {
    promotionTipList.push(local("timeLimitedDiscount"));
  }
  return promotionTipList;
};

export const getProductAttrListByInputList = (data = "") => {
  let attr = [];
  try {
    if (data.includes("[{") && data.includes("}]")) {
      attr = JSON.parse(data);
    } else {
      attr = data.split(",").map((v) => ({
        uid: uid(8),
        name: v,
      }));
    }
  } catch (err) {
    attr = [];
  }
  return attr;
};
export const getAttrOptionMap = (attr) => {
  const map = (attr.options || []).reduce((t, c) => {
    t[c.uid] = c;
    return t;
  }, {});
  const cMap = (attr.inputList || []).reduce((t, c) => {
    t[c.uid] = c;
    return t;
  }, map);
  return cMap;
};

export const filterCart = (item) => {
  return item.realStock > 0 && item.realStock && item.valid;
};

export const getParamsByOrderStatus = (status) => {
  let params = {};
  switch (status) {
    case statusEnum.all:
      break;
    case statusEnum.unpaid:
      params = {
        financialStatusList: [
          financialStatusEnum.pending,
          financialStatusEnum.authorized,
        ],
      };
      break;
    case statusEnum.preparing:
      params = {
        financialStatusList: [financialStatusEnum.paid],
        fulfillmentStatusList: [fulfillmentStatusEnum.hold],
      };
      break;
    case statusEnum.arriving:
      params = {
        financialStatusList: [financialStatusEnum.paid],
        fulfillmentStatusList: [
          fulfillmentStatusEnum.fulfilled,
          fulfillmentStatusEnum.partial,
        ],
      };
      break;
    case statusEnum.completed:
      params = {
        financialStatusList: [financialStatusEnum.paid],
        fulfillmentStatusList: [fulfillmentStatusEnum.confirmed],
      };
      break;
    case statusEnum.cancelled:
      params = {
        financialStatusList: [
          financialStatusEnum.canceled,
          financialStatusEnum.partially_refunded,
          financialStatusEnum.refunded,
          financialStatusEnum.refunding,
        ],
      };
      break;
    default:
  }
  return params;
};

export const covertOrderStatus = ({ financialStatus, fulfillmentStatus }) => {
  if (
    [financialStatusEnum.pending, financialStatusEnum.authorized]?.includes(
      financialStatus
    )
  ) {
    return statusEnum.unpaid;
  }
  if (
    financialStatus === financialStatusEnum.paid &&
    fulfillmentStatus === fulfillmentStatusEnum.hold
  ) {
    return statusEnum.preparing;
  }
  if (
    financialStatus === financialStatusEnum.paid &&
    [fulfillmentStatusEnum.fulfilled, fulfillmentStatusEnum.partial]?.includes(
      fulfillmentStatus
    )
  ) {
    return statusEnum.arriving;
  }
  if (
    financialStatus === financialStatusEnum.paid &&
    fulfillmentStatus === fulfillmentStatusEnum.confirmed
  ) {
    return statusEnum.completed;
  }
  if (
    [
      financialStatusEnum.canceled,
      financialStatusEnum.partially_refunded,
      financialStatusEnum.refunded,
      financialStatusEnum.refunding,
    ]?.includes(financialStatus)
  ) {
    return statusEnum.cancelled;
  }
};

export const transformThirdOrder = (order) => {
  let noAddress = false;
  if (
    !order.shippingProvince &&
    !order.shippingCity &&
    !order.shippingCountry &&
    !order.shippingZip &&
    !order.shippingAddress2 &&
    !order.shippingAddress1
  ) {
    noAddress = true;
  }

  return {
    id: order.id,
    status: covertOrderStatus({
      financialStatus: order.financialStatus,
      fulfillmentStatus: order.fulfillmentStatus,
    }),
    orderSn: order.orderNo,
    createTime: order.createdAt,
    totalAmount: order.productTotal,
    payAmount: order.realTotal,
    payChannel: payMethodMap[order.paymentMethod],
    orderItemList: [
      {
        id: order.lineItemId,
        orderId: order.id,
        orderSn: order.orderNo,
        productPic: "/static/product_img_default.jpeg",
        productName: order.lineItemName,
        productPrice: order.lineItemTotal,
        promotionName: order.lineItemPromotionDetail,
        productAttr: JSON.stringify(
          order.lineItemSpecification?.split("/")?.map((v) => ({ value: v }))
        ),
        thirdOrder: true,
        discountAmount: order.discountAmount,
        productQuantity: order.lineItemQuantity,
      },
    ],
    quantity: order.lineItemQuantity,
    thirdOrder: true,
    paymentTime: order.paidAt,
    promotionAmount: order.lineItemTotalDiscount,
    tax: order.taxes,
    currency: currencyNameMap[order.currency],
    receiverName: [order.shippingLastName,
      order.shippingFirstName]?.filter(Boolean)?.join(" "),
    receiverPhone: order.shippingPhone,
    receiverProvince: order.shippingProvince,
    receiverCity: order.shippingCity,
    receiverRegion: order.shippingCountry,
    receiverPostCode: order.shippingZip,
    receiverDetailAddress: `${order.shippingAddress2 || ""} ${
      order.shippingAddress1 || ""
    }`,
    noAddress
  };
};

export const getDisabledSkuMap = ({ specList, selectedSku, skuList }) => {
  const skuMap = selectedSku.spDataObj || {};
  const spDataArr = selectedSku.spDataArr || [];
  const disabledMap = spDataArr?.reduce((t, item) => {
    const nextAttr = spDataArr?.filter((it) => it.attrId !== item.attrId);
    const stockSkuMap = skuList?.reduce((total, current) => {
      const spData = current.spDataObj;
      const isMatch =
        nextAttr?.every(
          (attr) => skuMap[attr.attrId] === spData[attr.attrId]
        ) && current.stock > 0;
      if (isMatch) {
        total[spData[item.attrId]] = true;
      }
      return total;
    }, {});
    return {
      ...t,
      ...(specList
        .find((it) => it.id === item.attrId)
        ?.valueList?.reduce((total, current) => {
          if (!stockSkuMap[current.uid]) {
            total[current.uid] = true;
          }
          return total;
        }, {}) || {}),
    };
  }, {});
  return disabledMap;
};
